
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class IssueMaterialGrid extends Serenity.EntityGrid<IssueMaterialRow, any> {
        protected getColumnsKey() { return 'Production.IssueMaterial'; }
        protected getDialogType() { return IssueMaterialDialog; }
        protected getIdProperty() { return IssueMaterialRow.idProperty; }
        protected getInsertPermission() { return IssueMaterialRow.insertPermission; }
        protected getLocalTextPrefix() { return IssueMaterialRow.localTextPrefix; }
        protected getService() { return IssueMaterialService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(67);
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[67].AutoPosting;
            this.editItem(<IssueMaterialRow>{
                VoucherNo: voucherNo,
                CompanyId: Q.Authorization.userDefinition.CompanyId,
                FinancialYearId: Q.Authorization.userDefinition.FinancialYearId,
                UserId: Q.Authorization.userDefinition.UserId,
                EmployeeId: 0,
                VoucherTypeId: 67,
                TransDate: now.toDateString(),
                AutoPosting: autoposting

            });
        }
    }
}